export enum TransactionType {
    Depopulate = -2,  //return main stock to supplier
    Return = -1,
    Issue = 0,
    Transfer = 1,
    Populate = 2,   //fill main stock from supplier
}